import {AxiosError} from 'axios';
import {
  BackendErrorData,
  parseApiError,
} from '../../utils/custom-errors/parseApiError';
import {apiClient} from '../apiClient';
import {IGetClientsResponse} from '../types/client.type';

import type {
  ClientQueryParams,
  GetClientApiResponse,
  LoadentityRequestParams,
} from '../types/client.type';
import type {
  LoadEntityResponseParams,
  EntityRequestParams,
} from '../types/client.type';
const CLIENTS_BASE_URL = 'projectmanagement/api/v1/entity';

interface IGetClientsParams {
  EntityLabel?: string;
  PageNumber?: number;
  PageSize?: number;
  SortingColumn?: string;
  SortingOrder?: string;
}

export const getClients = async (
  params: IGetClientsParams
): Promise<IGetClientsResponse> => {
  const {EntityLabel, PageNumber, PageSize, SortingColumn, SortingOrder} =
    params;

  const queryParams = {
    ...(EntityLabel && {EntityLabel}),
    ...(PageNumber && {PageNumber}),
    ...(PageSize && {PageSize}),
    ...(SortingColumn && {SortingColumn}),
    ...(SortingOrder && {SortingOrder}),
  };

  const {data} = await apiClient.get(`${CLIENTS_BASE_URL}/list`, {
    params: queryParams,
  });

  return data;
};

export const deleteClient = async (
  entityId: number
): Promise<{message: string}> => {
  try {
    const response = await apiClient.delete(
      `${CLIENTS_BASE_URL}/${entityId}`
    );
    return response.data;
  } catch (error) {
    throw parseApiError(
      error as AxiosError<BackendErrorData>,
      'ClientManagement'
    );
  }
};

export const Loadentity = async (
  payload: LoadentityRequestParams
): Promise<LoadEntityResponseParams> => {
  const response = await apiClient.post<LoadEntityResponseParams>(
    `${CLIENTS_BASE_URL}/loadaddentity`,
    {
      params: payload,
      headers: {
        accept: 'text/plain',
        'Content-Type': 'application/json',
      },
    }
  );

  return response.data;
};

export const addEntity = async (
  payload: EntityRequestParams
): Promise<EntityRequestParams> => {
  try {
    const response = await apiClient.post(
      `${CLIENTS_BASE_URL}/entities`,
      payload,
      {
        headers: {
          accept: 'text/plain',
          'Content-Type': 'application/json',
        },
      }
    );
    return response.data;
  } catch (error) {
    throw parseApiError(
      error as AxiosError<BackendErrorData>,
      'ClientManagement'
    );
  }
};

export const getClientData = async (queryParams: ClientQueryParams) => {
  try {
    const {data} = await apiClient.get<GetClientApiResponse>(
      `${CLIENTS_BASE_URL}/edit`,
      {
        params: queryParams,
      }
    );
    return data;
  } catch (error) {
    throw parseApiError(
      error as AxiosError<BackendErrorData>,
      'ClientManagement'
    );
  }
};
